




















































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'

@Component({
  components: { BuilderDeviceHighlight },
})
export default class BuilderDeviceChatItemStub extends Vue {
  @Prop({ required: false, type: String }) color!: string

  @Prop({ required: true, type: String }) title!: string

  @Prop({ required: true }) image!: string | File | Blob | null

  @Prop({ default: false, type: Boolean }) locked!: string
  @Prop({ default: false, type: Boolean }) isGpt!: string

  @Prop({ type: String }) highlight!: null | 'chat' | 'avatar' | 'lock' | 'delete'

  get imageUrl(): string | null {
    if (!this.image) {
      return null
    }

    return this.image instanceof Blob ? URL.createObjectURL(this.image) : this.image
  }

  onLockClick(): void {
    this.$emit('lock')
  }

  onDeleteClick(): void {
    this.$emit('delete')
  }
}
